var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"light":""}},[_c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }